import { render, staticRenderFns } from "./list-culture.vue?vue&type=template&id=0c613017&scoped=true&"
import script from "./list-culture.vue?vue&type=script&lang=js&"
export * from "./list-culture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c613017",
  null
  
)

export default component.exports